<!--Contact us-->
@if (!userStatus.PAID) {
  <section class="contact tw-px-4 tw-pt-4 tw-pb-0 tw-m-0" id="contact">
    <div class="header">
      <div class="fw-700 font20" i18n="@@reachUsNew">Connect with us</div>
      <div class="desc"></div>
    </div>
    <div class="cardHolder tw-mt-4">
      <div class="card tw-p-4 tw-mr-2"><a
        href="mailto:hello@cureskin.com?Subject={{user?.get(&quot;MobileNumber&quot;)}}, {{user?.get(&quot;PatientName&quot;)}}"
        (click)="handleSupport('mail')"><img class="mail svg-black" src="https://cdn.cureskin.com/app/img/mail.svg" />
        <div class="text">
          <div class="fontS3 clr-secondary" i18n="@@mailUsAtNew">Mail<span class="tw-lowercase"> us at</span></div>
          <div class="info">hello&#64;cureskin.com</div>
        </div>
      </a></div>
      <div class="card tw-p-4"><a href="tel:081-500-96500" (click)="handleSupport('phone')"><img class="call svg-black"
        src="https://cdn.cureskin.com/app/img/call.svg" />
      <div class="text">
        <div class="fontS3 clr-secondary" i18n="@@callUsAtNew">Call<span class="tw-lowercase"> us on</span></div>
        <div class="info">081-500-96500</div>
      </div>
    </a></div>
  </div>
</section>
}
